import { filterCapitalize } from "@/filters/capitalize";
import { SelectItem } from "@/models/api/SelectItem";
import i18n from "@/plugins/i18n";

export enum KSEF_STATUS_ENUM {
  Unknown = 0,
  Sent = 1,
  Accepted = 2,
  Rejected = 3,
  Applicable = 4,
  NotApplicable = 5,
  Stop = 6,
}

export const ksefStatusTranslations = [
  { value: KSEF_STATUS_ENUM.Unknown, text: filterCapitalize(i18n.t("ksef.unknown")) } as SelectItem,
  { value: KSEF_STATUS_ENUM.Sent, text: filterCapitalize(i18n.t("ksef.sent")) } as SelectItem,
  { value: KSEF_STATUS_ENUM.Accepted, text: filterCapitalize(i18n.t("ksef.accepted")) } as SelectItem,
  { value: KSEF_STATUS_ENUM.Rejected, text: filterCapitalize(i18n.t("ksef.rejected")) } as SelectItem,
  { value: KSEF_STATUS_ENUM.Applicable, text: filterCapitalize(i18n.t("ksef.applicable")) } as SelectItem,
  { value: KSEF_STATUS_ENUM.NotApplicable, text: filterCapitalize(i18n.t("ksef.notApplicable")) } as SelectItem,
  { value: KSEF_STATUS_ENUM.Stop, text: filterCapitalize(i18n.t("ksef.stop")) } as SelectItem,
];
